import React from 'react';
import classes from "views/MapView/mapview.module.scss";
import BackArrow from "assets/images/back-arrow.png";
import {citiesMap} from "config/cityData";

const LocationsList = ({ setCity, onCityClick, cityLocations, city}) => {
  return (
    <div className={classes.listContainer}>
      <div className={classes.header}>
        <img onClick={() => setCity(null)} src={BackArrow} alt=""/>
        <h2 className="mb-0">{citiesMap[city]}</h2>
      </div>
      <div className={classes.list}>
        {cityLocations.map((location) => {
          const loc = location?.acf?.google_map_location || null;
          const coords = loc ? [loc.lng, loc.lat] : [];
          return (
            <div
              key={location.id}
              className={classes.listItem}
              onClick={onCityClick(location, coords)}
            >
              <h4 className={classes.itemTitle}>
                {location?.title?.rendered}
              </h4>
              {location.cuisine_type ? (
                <span className={classes.itemSubtitle}>
                  {location.cuisine_type}
                </span>
              ) : null}
              {location.acf?.address_field ? (
                <p className={classes.address}>
                  {location.acf.address_field}
                </p>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LocationsList;